import { createAsyncThunk } from '@reduxjs/toolkit'
import * as service from './howToDocument.services'
import { paginationData } from '../Pagination/reducers'
import { toast } from 'react-toastify'

export const HowToDocumentCategoryList = createAsyncThunk(
    'How-to-document/Category/listing',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const res = await service.HowToDocumentCategoryListApi(data)

            if (data.params._limit) {
                // Pagination Section
                const limit = data.params._limit || 10
                const TotalPage = Math.ceil(res.totalRecords / limit) || 1
                const paginationObj = {
                    page: data.params._page,
                    totalPage: TotalPage,
                    totalRecords: res?.totalRecords
                }
                dispatch(paginationData(paginationObj))
            }

            return res
        } catch (err) {
            if (data.params._limit) {
                const TotalPage = 1
                const paginationObj = {
                    page: 1,
                    totalPage: TotalPage,
                    totalRecords: 1
                }
                dispatch(paginationData(paginationObj))
            }
            if (!err.response) {
                throw err
            }
            toast.error(err.response.data)

            return rejectWithValue(err.response.data)
        }
    }
)

export const HowToDocumentCategoryCreate = createAsyncThunk(
    'How-to-document/Category/create',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.HowToDocumentCategoryCreateApi(data)

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return rejectWithValue(err.response.data)
        }
    }
)
export const HowToDocumentCategoryGetOne = createAsyncThunk(
    'How-to-document/Category/getOne/create',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.HowToDocumentCategoryGetOneApi(data)

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            toast.error(err.response.data)

            return rejectWithValue(err.response.data)
        }
    }
)

export const HowToDocumentCategoryUpdate = createAsyncThunk(
    'How-to-document/Category/update',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.HowToDocumentCategoryUpdateApi(data)

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return rejectWithValue(err.response.data)
        }
    }
)

export const HowToDocumentCategoryDelete = createAsyncThunk(
    'How-to-document/Category/delete',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.HowToDocumentCategoryDeleteApi(data)

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return rejectWithValue(err.response.data)
        }
    }
)

export const HowToDocumentCategoryPublish = createAsyncThunk(
    'How-to-document/Category/publish',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.HowToDocumentCategoryPublishApi(data)

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return rejectWithValue(err.response.data)
        }
    }
)
///

///

///
export const HowToDocumentSubCategoryList = createAsyncThunk(
    'How-to-document/SubCategory/listing',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const res = await service.HowToDocumentSubCategoryListApi(data)

            if (data.params._limit) {
                // Pagination Section
                const limit = data.params._limit || 10
                const TotalPage = Math.ceil(res.totalRecords / limit) || 1
                const paginationObj = {
                    page: data.params._page,
                    totalPage: TotalPage,
                    totalRecords: res?.totalRecords
                }
                dispatch(paginationData(paginationObj))
            }

            return res
        } catch (err) {
            if (data.params._limit) {
                const TotalPage = 1
                const paginationObj = {
                    page: 1,
                    totalPage: TotalPage,
                    totalRecords: 1
                }
                dispatch(paginationData(paginationObj))
            }
            if (!err.response) {
                throw err
            }
            toast.error(err.response.data)

            return rejectWithValue(err.response.data)
        }
    }
)

export const HowToDocumentSubCategoryCreate = createAsyncThunk(
    'How-to-document/SubCategory/create',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.HowToDocumentSubCategoryCreateApi(data)

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return rejectWithValue(err.response.data)
        }
    }
)

export const HowToDocumentSubCategoryGetOne = createAsyncThunk(
    'How-to-document/SubCategory/getOne/create',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.HowToDocumentSubCategoryGetOneApi(data)

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            toast.error(err.response.data)

            return rejectWithValue(err.response.data)
        }
    }
)
export const HowToDocumentSubCategoryUpdate = createAsyncThunk(
    'How-to-document/SubCategory/update',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.HowToDocumentSubCategoryUpdateApi(data)

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return rejectWithValue(err.response.data)
        }
    }
)

export const HowToDocumentSubCategoryDelete = createAsyncThunk(
    'How-to-document/SubCategory/delete',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.HowToDocumentSubCategoryDeleteApi(data)

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return rejectWithValue(err.response.data)
        }
    }
)

export const HowToDocumentSubCategoryPublish = createAsyncThunk(
    'How-to-document/SubCategory/publish',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.HowToDocumentSubCategoryPublishApi(data)

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return rejectWithValue(err.response.data)
        }
    }
)

///
///
///
///
export const DocumentList = createAsyncThunk(
    'How-to-document/document/listing',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const res = await service.DocumentListApi(data)

            if (data.params._limit) {
                // Pagination Section
                const limit = data.params._limit || 10
                const TotalPage = Math.ceil(res.totalRecords / limit) || 1
                const paginationObj = {
                    page: data.params._page,
                    totalPage: TotalPage,
                    totalRecords: res?.totalRecords
                }
                dispatch(paginationData(paginationObj))
            }

            return res
        } catch (err) {
            if (data.params._limit) {
                const TotalPage = 1
                const paginationObj = {
                    page: 1,
                    totalPage: TotalPage,
                    totalRecords: 1
                }
                dispatch(paginationData(paginationObj))
            }
            if (!err.response) {
                throw err
            }
            toast.error(err.response.data)

            return rejectWithValue(err.response.data)
        }
    }
)

export const DocumentCreate = createAsyncThunk(
    'How-to-document/document/create',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.DocumentCreateApi(data)

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return rejectWithValue(err.response.data)
        }
    }
)

export const DocumentUpdate = createAsyncThunk(
    'How-to-document/document/update',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.DocumentUpdateApi(data)

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return rejectWithValue(err.response.data)
        }
    }
)

export const DocumentDelete = createAsyncThunk(
    'How-to-document/document/delete',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.DocumentDeleteApi(data)

            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return rejectWithValue(err.response.data)
        }
    }
)
